export { default as guid } from './tiny-guid';
